var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showType && _vm.count_down > 0)?_c('div',{staticClass:"report-contain",attrs:{"ddt-area":"上报组件","ddt-expose":"on"}},[_c('div',{staticClass:"report-box"},[_vm._v(_vm._s(_vm.count_down)+"s后完成任务")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }